<via-sku-time-series-top-bar></via-sku-time-series-top-bar>

<div class="e-sku-time-series-container">
    <via-sku-time-series-filter-bar (showAllPricesClick)="updateShowAllPrices($event)" (displayedPriceClick)="updateDisplayedPrice($event)"></via-sku-time-series-filter-bar>
    <via-sku-time-series-table [isShowingAllPrices]="isShowingAllPrices" [showRegularPrice]="showRegularPrice"></via-sku-time-series-table>
</div>
